/** Reconciles a tab's forced columns with the column selection a user saved for that list. */

/**
 * Merges a tab's forced columns into a saved column selection, leaving the saved order otherwise intact.
 * A missing forced id lands right after the nearest preceding tab column the selection already has,
 * and at the end when the selection has none of them.
 */
export const mergeForcedColumns = (persistedColumns: string[], forcedColumns?: string[], tabColumns?: string[]): string[] => {
   if (!forcedColumns || forcedColumns.length === 0) {
      return persistedColumns;
   }

   const merged = [...persistedColumns];
   const tabOrder = tabColumns || [];

   forcedColumns.forEach(forcedId => {
      if (merged.includes(forcedId)) {
         return;
      }

      // Walk back through the tab's own order for a column the selection kept, and sit right behind it
      let insertAt = merged.length;
      for (let position = tabOrder.indexOf(forcedId) - 1; position >= 0; position--) {
         const predecessorIndex = merged.indexOf(tabOrder[position]);
         if (predecessorIndex >= 0) {
            insertAt = predecessorIndex + 1;
            break;
         }
      }

      merged.splice(insertAt, 0, forcedId);
   });

   return merged;
};
